import React from "react";
import PageTitle from "../common/text/PageTitle";
import translate from "react-i18next/dist/commonjs/translate";

class SignOutPage extends React.Component {
  constructor(props) {
    super(props);

    this.signIn = this.signIn.bind(this);
  }

  signIn() {
    window.location = `${global.applicationPath}/`;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="dashboard-page">
        <div className="main-content">
          <PageTitle text={t("SignOutPageHeader")} />
          <div className="signoutPageContainer">
            <div className="button buttonPrimary" onClick={this.signIn}>
              <i className="buttonIcon fa fa-1 fa-user" />
              {t("SignInButtonText")}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate("translations")(SignOutPage);



// WEBPACK FOOTER //
// ./src/oidc/SignOutPage.js